export default __webpack_public_path__ + "static/media/3-stepRes.112543c0.png";